import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
const AUTH_LINK_TYPE_FLAG = "meten-auth-link-type";

function persistIncomingAuthLinkType() {
  if (typeof window === "undefined") return;

  const hashParams = new URLSearchParams(window.location.hash.replace(/^#/, ""));
  const queryParams = new URLSearchParams(window.location.search);
  const authType = hashParams.get("type") || queryParams.get("type");

  if (authType === "invite" || authType === "recovery") {
    window.sessionStorage.setItem(AUTH_LINK_TYPE_FLAG, authType);
  }
}

persistIncomingAuthLinkType();

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
export { AUTH_LINK_TYPE_FLAG };
